export const getItemSize = (itemsPerRow: number, gridSize: number) => {
  return Math.round(gridSize / itemsPerRow);
};

export const getMaskedValue = (value: any, min: number, max: number) => {
  if (value > max) {
    return max;
  }

  if (value < min) {
    return min;
  }

  return Number(value);
};
export const deepCompireObjects = (val1: any, val2: any) => {
  return JSON.stringify(val1) === JSON.stringify(val2);
};
export const setNumToFixNotRound = (num?: string) => {
  if (!num) {
    return 0;
  }

  const number = num.toString() || "0.00";

  if (Boolean(number?.match(/^-?\d+(?:\.\d{0,2})?/))) {
    const round = number.match(/^-?\d+(?:\.\d{0,2})?/);
    if (round) {
      return parseFloat(round[0]);
    }
    return 0;
  } else return 0;
};
export const numberFormatting = (num: number) => {
  let res = "";
  if (num) {
    res = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    return 0;
  }
  return res;
};
export const stringFormatting = (num: string) => {
  let res = "";
  if (num) {
    res = num.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    return "0.00";
  }
  return res;
};
export const moneyformatter = (num: any, normal?: boolean) => {
  if (num === "") {
    return num;
  }
  if (normal) {
    let res = "0.00";
    if (num) {
      //num = Math.floor(num * 100) / 100;
      if (typeof num === "number") {
        res = num.toString();
      } else {
        res = num;
      }
      const inc = res.includes(".");
      if (!inc) {
        res += ".00";
      }
      if (res.split(".")[1].length === 1) {
        res += "0";
      }
    }
    return parseFloat(res).toFixed(2);
  } else {
    return formatter.format(num);
  }
};
const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
export const stringFormate = (st?: string) => {
  let result = "";
  if (st) {
    result = st
      .replace(/<[^>]*>?/gm, "")
      .replace(/(\r\n|\n|\\n|\r)/gm, " ")
      .replace(/\&nbsp;/g, " ")
      .replace(/\amp;/g, " ");
  } else {
    result = "";
  }

  return result;
};
